define("settings/utils/discount", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  class Discount {
    constructor(response) {
      var _response$discount, _response$discount2, _response$discount3, _response$discount4, _response$discount5, _response$discount6;

      _defineProperty(this, "name", void 0);

      _defineProperty(this, "duration", void 0);

      _defineProperty(this, "endTime", void 0);

      _defineProperty(this, "percentOff", void 0);

      _defineProperty(this, "amountOff", void 0);

      _defineProperty(this, "appliesTo", void 0);

      _defineProperty(this, "futureAmount", void 0);

      _defineProperty(this, "futureAmountDiscounted", void 0);

      // flattens discount response from BE by setting private properties on same level and converts to camel case
      this.name = (_response$discount = response.discount) === null || _response$discount === void 0 ? void 0 : _response$discount.name;
      this.duration = (_response$discount2 = response.discount) === null || _response$discount2 === void 0 ? void 0 : _response$discount2.duration;
      this.endTime = (_response$discount3 = response.discount) === null || _response$discount3 === void 0 ? void 0 : _response$discount3.end_time;
      this.amountOff = (_response$discount4 = response.discount) === null || _response$discount4 === void 0 ? void 0 : _response$discount4.amount_off;
      this.appliesTo = (_response$discount5 = response.discount) === null || _response$discount5 === void 0 ? void 0 : _response$discount5.applies_to;
      this.percentOff = (_response$discount6 = response.discount) === null || _response$discount6 === void 0 ? void 0 : _response$discount6.percent_off;
      this.futureAmount = response.future_amount;
      this.futureAmountDiscounted = response.future_amount_discounted;
    }

    get discountAmount() {
      var _this$amountOff;

      return (_this$amountOff = this.amountOff) !== null && _this$amountOff !== void 0 ? _this$amountOff : this.futureAmount * (this.percentOff / 100);
    }

  }

  _exports.default = Discount;
});